<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Exam Management</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <add-exam-setup @created="handleCreated"/>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="row">
          <!-- Session Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedSession"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleSessionChange"
              :filterOption="false"
              :defaultValue="currentSession ? currentSession.id : ''"
            >
            <template v-for="schoolSession in schoolSessions">
              <a-select-option :value="schoolSession.id" :key="schoolSession.id">
                  {{schoolSession.name}}
                  <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
              </a-select-option>
            </template>
            </a-select>
          </div>
          <!-- Class Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="classSpinning">
              <a-select
                size="large"
                v-model="selectedClass"
                placeholder="All Classes"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleClassSelect"
                :filterOption="false"
                :defaultValue="undefined"
              >
                <a-select-option :value="undefined">All Classes</a-select-option>
                <template v-for="schoolClass in schoolClasses">
                  <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                  {{schoolClass.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <exam-setup-table :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash'

import ExamSetupTable from '@/components/bosemexam/setup/Table/index'
import AddExamSetup from '@/components/bosemexam/setup/Forms/Add/index'

export default {
  components: {
    ExamSetupTable,
    AddExamSetup,
  },
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
        this.getClasses()
      })
      .catch(error => {
        console.log(error)
      })
    this.getClassSectionExam()
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      selectedSession: undefined,
      selectedClass: undefined,
      schoolSessions: [],
      schoolClasses: [],
      classSpinning: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
    }
  },
  methods: {
    getClasses() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getClassSectionExam: function() {
      this.loading = true
      this.$http.get('/api/classsectionexam', {
        params: {
          session_id: this.selectedSession,
          class_id: this.selectedClass,
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    handleCreated: function() {
      this.getClassSectionExam()
    },
    handleUpdateTable: function() {
      this.getClassSectionExam()
    },
    handleSessionChange (value) {
      this.selectedClass = undefined
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.getClassSectionExam()
    },
    handleClassSelect(value) {
      this.selectedClass = value
      this.getClassSectionExam()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getClassSectionExam()
    },
    onChange(current) {
      this.current = current
      this.getClassSectionExam()
    },
  },
}
</script>
